import { useFetchAdministratorApi } from 'api/admin/administrators';
import { AdminStateContext } from 'contexts/admin_state_context';
import React from 'react';
import { Outlet } from 'react-router-dom';

export const AdminStateContainer = () => {
  const [currentAdmin, setCurrentAdmin] = React.useState({});
  const api = useFetchAdministratorApi();

  const reloadAdmin = () => {
    api.execute();
  };

  return (
    <AdminStateContext.Provider
      value={{ currentAdmin: currentAdmin, setCurrentAdmin: setCurrentAdmin, reloadAdmin: reloadAdmin }}
    >
      <Outlet />
    </AdminStateContext.Provider>
  );
};

export default AdminStateContainer;
